export default {
    topBar: { // 顶部导航栏
        homepage: '首 页',
        price: '价 格',
        aboutUs: '关于我们',
        blog:'技术博客',
        funSafety:'功能安全',
        clientCases: '客户案例',
        automotiveToolchain: '汽车工具链',
        industrialIntelligentManufacturing: '工业智造',
        informationSecurity: '信息安全',
        yingxiao:'MappingSpace私有部署终生免费版 - 查看详情',
        yingxiao1:'MappingSpace私有部署终生免费版',
        security :'安全',
        ai:'人工智能',
    },
    clientCase: {  //客户案例弹窗 
        oneName: '宁波拓普集团股份有限公司',
        twoName: '利氪科技有限公司',
        threeName: '宁波福尔达智能科技股份有限公司'
    },
    btn: {
        btnTrail: "免费试用",
        btnDocument: "产品文档",
        tryIt: "立即体验",
        contact: "联系我们",
        join: "我要加入团队",
        demo: '演示版申请',
        learn:'了解更多'
    },
    applyDialog: {
        title: '演示版申请',
        info: '填写信息后，我们将联系您为您演示',
        title2: '软件咨询',
        info2: '填写信息后，我们将联系您为您提供咨询服务',
        label:{
            name: '姓名',
            email: '企业邮箱',
            phone: '电话',
            careAbout: '主要关注软件哪些方面的功能：'
        },
        formInfo: {
            name: '请输入姓名',
            email: '请输入企业邮箱',
            emailFormatError: '企业邮箱格式错误',
            phone: '请输入电话',
            phoneFormatError: '电话号码格式错误'
        },
        confirm: '确认',
        cancel: '取消',
        /**
         * FIXME: pujingyu
         * 添加了ElMessage相关内容
         */
        success: '申请成功！',
        error: '申请失败！请重新尝试！'
    },
    homepage: { // 首页
        Jumbotron: { // 顶部巨幕
            // word1: '满足ASPICE标准的',
            // word2: '一站式需求 ',
            // word3: ' 开发 ',
            // word4: ' 测试管理平台'
            word3:'关注公众号，了解更多信息',
            word:'AI · Agile · ASPICE',
            word2: 'AI智能体驱动的ALM',
            carIndustry: '汽车行业的国产替代首选'
        },
        cooperation: { // 合作
            title: '九大管理场景',
            requirement: '需求管理',
            workItem: '工作项管理',
            test: '测试管理',
            baseline: '基线管理',
            change: '变更管理',
            publish: '发布管理',
            onlineJudge: '在线评审',
            document: '文档管理',
            agile: '敏捷看板',
            secondTitle:'<span>AI</span> · ASPICE · Agile → MappingSpace',
            description:'MappingSpace融合了当前AIGC领域的最新进展，将大语言模型用于生成研发过程文档，大大提升了研发进度。研发工程师能够在MappingSpace中，直接生成需求、架构、测试用例等研发过程文档，并能将其直接生成研发任务，进行任务跟踪。',
            oneAI:{
                title:'AI补充',
                description:'对已有的研发过程文档，使用AI技术进行补充及完善',
            },
            twoAI:{
                title:'AI绘图',
                description:'基于架构设计文档，生成可编辑的静态架构图、动态架构图等，大幅提高架构师的工作效率',
            },
            threeAI:{
                title:'AI代码',
                description:'基于已有的详细设计文档，生成代码框架，大幅提高编码工程师的编码速度',
            }
        },
        replace: '可替代',
        requirement: { // 需求管理
            info: "需求管理",
            title: '思维导图式需求管理，天生最强追溯性',
            desc: '借助思维导图浮窗，快速查看并编辑任意任务属性；快速查看任意需求的上下文及其关联节点；借助图例分颜色显示状态、责任人等；需求编写、任务分配效率提升10倍以上。',
            li1: '数百万元',
        },
        workItem: {
            info: "工作项管理",
            title: '关联透视图与覆盖度查询',
            desc: '通过查看关联任务项的类型，实时显示任意节点的任意类型覆盖度（需求、架构、测试用例覆盖度等等），完全满足ASPICE工作项的追溯要求。',
            li1: '数十万元',
        },
        test: {
            info: "测试管理",
            title: '精准测试计划创建，自动添加测试用例',
            desc: '思维导图创建测试用例，还能通过思维导图执行测试用例；' +
                '测试用例执行完，自动生成测试报告，还可一键导出；' +
                '测试报告涵盖了Bug数据一览、测试用例数据一览、需求覆盖度报告、详细执行结果、API测试报告。',
            li1: '数万元',
            li2: '开源'
        },
        baseline: {
            info: "基线管理",
            title: '创建开发基线，查看基线变更记录',
            desc: '将节点加入基线之后，用户可以开始一条基线。用户可自由选择是否锁定基线，锁定后的基线无法直接变更，必须通过变更委员会的在线评审。基线内容的新增、变更和删除，都有清晰的审计记录。',
            li1: '数百万元',
            li2: '开源',
        },
        change: {
            info: "变更管理",
            title: '创建变更分支，多人强制评审',
            desc: '针对任意类型的工作项，均可以发起变更请求，并邀请变更委员会或指定人进行评审\n' +
                '定制评审通过规则，全面掌握变更影响。',
            li1: '数百万元',
        },
        publish: {
            info: "发布管理",
            title: '版本发布历史记录一览',
            desc: '创建发布版本后，版本可与Sprint关联，自动将Sprint中的issue加入到发布版本中，指定版本发布责任人\n' +
                '关联测试计划，随时查看测试计划进度，以便决定版本是否可以释放，自动出具版本发布报告。',
            li1: '开源',
        },
        onlineJudge: {
            info: "在线评审",
            title: '思维导图评审模式，高效当仁不让',
            desc: '对需求、测试用例等各类issue类型进行分发，邀请评审\n' +
                '多人同步评审，批量快速填写评审结果，定制评审通过规则，实时展示评审结果。',
            li1: '邮件',
            li2: '线下评审会',
            li3: '数天时间',
        },
        document: {
            info: "文档管理",
            title: '在线文档实时协同编辑',
            desc: '适合企业的多人协同编辑文档，形成企业流程、文档的知识库\n' +
                '一键将文档转化成思维导图，作为任务跟踪，文档视图与思维导图视图，无缝切换。',
            li1: '飞书',
            li2: '数十万元',
            li3: '数万元',
            li4: '开源',
        },
        agile: {
            info: "敏捷看版",
            title: '支持Scrum和Kanban，让敏捷开发团队更高效',
            desc: '按照思维导图、或按照责任人模式查看敏捷看板\n' +
                '任务流快速流转，自动出具冲刺报告。',
            li1: '数十万元',
        },
        case: {
            Aotecar: '拓普',
            Tongyu: '利氪科技',
            Fuerda: '福尔达',
            caseTitle1: '全球领先的新能源汽车零部件平台',
            caseTitle2:'线控底盘关键技术领跑者',            
            caseTitle3: '高端汽车智能光电系统',
            caseTitle1Text: '借助MappingSpace研发管理系统，拓普完成了项目数据的整体线上迁移，满足严苛的欧洲客户要求',
            caseTitle2Text:'借助MappingSpace研发管理系统，利氪科技实现了线控底盘功能安全项目的高效管理，从而满足ISO26262提出的标准要求。',            
            caseTitle3Text: '借助MappingSpace研发管理系统，实现了对IBM Doors软件的国产替代，并大大超出了原有工具的使用效率和使用体验。',
            caseRead: '案例分析',
            moreResources: '更多资源',
            resourceTitle1: '汽车工具链',
            resourceTitle2:'工业智造',            
            resourceTitle3: '下载发展白皮书',
            resourceTitle4: '下载软件测试报告',
            resourceTitle5: '下载管理白皮书',
            resourceTitle1Text: 'MappingSpace为您带来更全面、更懂汽车的研发管理工具链',
            resourceTitle2Text:'针对航电、医疗器械等工业智造领域提供的定制化解决方案',            
            resourceTitle3Text: 'AutoSemo中国汽车基础软件发展白皮书 3.0',
            resourceTitle4Text:'AutoSemo中国汽车基础软件测试研究报告 1.0',
            resourceTitle5Text:'汽车研发过程管理白皮书',
            whitePaperDialogInfo: '填写以下信息，即可下载',
            whitePaperEmailLabel: '邮箱地址',
            whitePaperEmailPlaceholder: '请输入邮箱地址',
            whitePaperPhoneLabel: '联系电话',
            whitePaperPhonePlaceholder: '请输入手机号码',
            whitePaperTip: '提交后我们将向您的邮箱发送下载链接，请注意查收',
            whitePaperConfirm: '确认并提交',
            whitePaperEmailError: '请输入有效的邮箱地址',
            whitePaperPhoneError: '请输入有效的手机号码',
            whitePaperSuccess: '提交成功，请注意查收邮件',
            whitePaperError: '信息提交失败，请稍后重试',
        }
    },
    footer: { // 页脚
        header: {
            title: ' 汽车软件工具箱  我们期待您的加入',
            desc: "想了解更多·请咨询  support{'@'}ytdevops.com",
            button: '我要加入团队'
        },
        contact: {
            product: '产品详情',
            free: '免费试用',
            longTerm: '长期使用',
            company: '企业信息',
            aboutUs: '关于我们',
            joinUs: '加入我们',
            ITtool: 'IT-TOOLS',
            service: '企业服务',
            address: '企业地址',
            addLine1: '苏州市漕湖街道观塘路1号',
            addLine2: '西交大漕湖科技园B幢301室42号',
            privacyPolicy: '隐私协议',
            termsOfUse: '用户须知',
            china:'中国',
            overseas: '海外',
            OfficialAccounts: '公众号',
            WeChatChannel: '视频号',

            

        },
        main: {
            title: '云体科技',
            contact: '联系我们',
            right: '版权所有：c   2022 云体科技',
            company: '主办单位：苏州云体科技有限公司',
            icp: 'ICP备案号：苏ICP备2021051249号-1',
            record: '苏公网安备 32050702011070号',
            licence:'ICP许可证：苏B2-20240943',
        }
    },
    price: { // 价格
        Jumbotron: {
            title: '软件优势',
            desc: '·汽车软件工具箱·以DevOps为中心·提高开发测试运维效率·'
        },
        // words: {
        //     word1: '满足',
        //     word2: 'For the automobile industry',
        //     word3: 'Ultra strong',
        //     word4: 'In traceability via mind map',
        //     word5: 'Relationship diagram',
        //     word6: 'Monitoring coverage',
        //     word7: 'Baseline management',
        //     word8: 'Baseline change audit',
        //     word9: 'Online review',
        //     word10: 'Real-time record of review results'
        // },
        compare: {
            item1: '是否满足汽车行业ASPICE标准',
            item2: '思维导图结构·最强追溯性',
            item3: '关联透视图',
            item4: '需求Word视图',
            item5: '基线管理',
            item6: '分支变更管理',
            item7: '在线评审',
            item8: '测试用例管理'
        },
        infoCard: {
            bar1: '满足汽车行业ASPICE标准',
            bar2: '超强追溯性 高阶思维导图',
            bar3: '关联透视图 覆盖度监测',
            bar4: '基线管理 基线变更审计',
            bar5: '在线评审 实时评审记录'
        },
        mid: {
            title: '权威安全认证·20项特权·全汽车人才团队',
            desc: '满足ASPICE标准的一站式研发管理平台'
        },
        heightspe:{
            height1:'30',
            height2:'30',
        },
        priceCard: {
            people: '适用人群',
            feature: '产品特性',
            version: {
                free1: '云端免费版',
                free2: '本地免费版',
                enterprise: '云端企业版',
                selfHosting: '本地企业版'
            },
            onTrial:{
                Trial1:'适用：100人及以下',
                Trial2:'适用：10人及以上',
                Trial3:'适用：30人及以上团队',
            },
            userNumber: {
                number1: "100人及以下",
                number2: "10人及以上",
                number3: '30人及以上团队'
            },
            priceValue: {
                price1: "0元",
                price2: "/人月",
                price3: "五折",
                price4: "尝鲜价: ",
                price5: "96元"
            },
            featureList: {
                featureTitle: '全网特权',
                item1: '托管方式',
                item2: '适用用户数量',
                item3: '存储空间',
                item4: '文件层次限制',
                item5: '用户权限管理',
                item6: '批量导入导出Excel',
                item7: '变更规则设置',
                item8: '评审规则设置',
                item9: '项目模板',
                item10: '功能范围',
                item11: '授权时长',
                item12: '授权项目',
                item13: '价格',
            },
            projectList:{
                item1:'甘特图',
                item2:'V模型全景图',
                item3:'自动化工作流',
                item4:'知识库',
                item5:'AI机器人',
                onePro:'1个项目',
            },
            userList: {
                userTitle: '用户数量与价格',
                item1: '100人',
                item2: '50人',
                item3: '100人',
                item4: '250人',
                item5: '500人',
                item6: '1000人',
                item7: '>1000人'
            },
            peoplePrice:{
                item1:'58元/人月',
                item2:'55元/人月',
                item3:'50元/人月',
                item4:'44元/人月',
                item5:'38元/人月',
            },
            level:'三 层',
            capacity:'1 GB',
            cloud: '云托管',
            notLimited: '不限',
            n2: '全部功能',
            n3: '6个月',
            n4: '永久',
            n5: '3个',
            n6: '按模块采购',
            n7: '私有部署',
            enterprisePrice: '998$/月',
            contactUs: "联系我们",
            free: '免费体验版',
            priceTemplate: '元/人月',
            price1: '永久免费',
            notProvide: '不提供',
            plz: '请联系我们',
            private:'为您打造私人部署',
            hot: "热门"
        },
        priceContrast: {
            function: '功能',
            ease: '易用性',
            xin:'信创支持',
            isxin:'是否支持信创',
            price: '成本',
            contrastname: '对比',
            contrast: {
                li1: '是否支持AI生成',
                li2: '是否满足汽车行业ASPICE标准',
                li3: '思维导图结构·最强追溯性',
                li4: 'V模型/W模型追溯全景图',
                li5: 'Word/Excel/ReqIF导入导出',
                li6: '在线架构图绘制',
                li7: '基线管理',
                li8: '变更管理',
                li9: '在线评审/评审数据报表',
                li10: '测试用例管理',
                li11: '学习成本',
                li12: '以私有化部署版本估计',
                li13: 'UI界面设计',
                li14: '系统语言',
                li15: '购买/运维成本',
                li16:'二次开发成本'
            },
            polarion: {
                li1: '无评审数据报表',
                li2: '非常高，建议私有化部署试用后评价',
                li3: '非常高',
                li4:'Windows XP 页面设计风格',
                li5: '不支持中文',
                li6: '购买费用高，每年高昂的运维升级费用',
                li7: '国外软件，国内仅代理销售公司提供技术支持，没有源代码，二开成本很高',
            },
            Codebeamer: {
                li1: '额外购买插件',
                li2: '二次开发',
                li3: '额外购买插件',
                li4: '偏高，中文培训材料有限，界面设计较复杂',
                li5: '中等',
                li6: '部分',
                li7: 'Windows 7 页面设计风格',
                li8: '不支持中文',
                li9: '购买费用高，每年高昂的运维升级费用，不支持买断',
                li10: '国外软件，国内仅代理销售公司提供技术支持，没有源代码，二开成本很高',
                
            },
            mappingSpace: {
                li1: '低，丰富的操作演示视频，简洁的页面设计',
                li2: '中等',
                li3: 'Windows 11 页面设计风格',
                li4: '支持中英德日俄5种语言',
                li5: '价格更有竞争力，免费升级到最新版本，支持买断',
                li6:'国产自研，源代码可控，原厂开发团队技术支持，二开成本低',
            }
        }
    },
    aboutUs: { // 关于我们
        main: {
            title: '苏州云体科技有限公司',
            desc: `         面向工业智造、AI赋能研发，云体科技致力于打造AI时代的工业软件。在帮助智能智造企业数字化的基础上，进一步加深AI对研发过程的全方位赋能，加速工业产品研发，提升工业产品安全合规及质量标准。
         云体科技，立志成为AI ALM领域全球第一品牌。`,
            desc2: '——云体科技',
            heroTag: '关于云体科技',
            heroDesc1:'为汽车研发团队\n构建更高效的工程协作方式',
            heroDesc: '云体科技专注于 AI、Agile 与 ASPICE 融合的一站式研发管理平台。我们相信优秀工具来自真实工程现场，也来自充分信任工程师的组织方式。',
            heroCard1Title: 'AI',
            heroCard1Sub: '智能体驱动',
            heroCard2Title: 'AGILE',
            heroCard2Sub: '敏捷组织',
            heroCard3Title: 'ASPICE',
            heroCard3Sub: '过程合规'
        },
        values: { // 价值观
            title: '我们的价值观',
            sincerity: '真诚',
            vision: '远见',
            collaboration: '协作',
            selfDrive: '自驱'
        },
        recruiting: { // 招聘
            title: '快来加入我们吧',
            engineering: 'Engineering工程',
            frontend: '前端软件工程师',
            backend: '后端软件工程师',
            design: 'Design设计',
            UI: 'UI设计师',
            RD: '研发工程师',
            devops: 'Devops运维工程师',
            button: '马上加入'
        },
        new:{
            awa:'荣誉墙',
            kehu:'客户案例',
            res:'用户反馈',
            faq:'常见问题板块',
            title1:'云体科技技术专栏',
            more:"查看更多",
            title2:'发展历程',
            milestoneIntro:'从汽车 ALM 国产化启程，MappingSpace 持续深耕研发管理与功能安全，以技术创新推动产品迭代与行业实践落地。',
            workWayTitle:'我们的工作方式',
            workWayIntro:'把高信任、强工程能力和清晰项目收益机制放在一起，让团队在更少摩擦中交付更好的产品。',
            workWay1Title:'远程办公，基于信任',
            workWay1Desc:'我们以信任为基础，为团队提供灵活的远程办公方式，以清晰的目标和可靠的成果共同推动工作。',
            workWay2Title:'早 9 晚 6，高效完成',
            workWay2Desc:'工作时间为早9晚6。我们反对表演式工作。如果要依靠加班才能完成工作，要么方向不对，要么能力不够。',
            workWay3Title:'项目奖金，贡献分配',
            workWay3Desc:'每签约一个正式项目，我们会拿出固定金额分给所有项目同事，并基于每个人的贡献大小进行分配。',
            workWay4Title:'工程师文化，扁平沟通',
            workWay4Desc:'推崇工程师文化和扁平化沟通。产品决策进行充分的技术评估与讨论，尊重工程师的意见。',
            cultureTitle:'让工程师把时间花在真正重要的事上',
            cultureIntro:'我们反对低效流程堆叠，也反对用加班掩盖问题。好的组织方式应该让复杂工作变清楚，让专业判断被看见。',
            culture1Title:'信任优先',
            culture1Desc:'用制度表达相信',
            culture2Title:'目标清晰',
            culture2Desc:'把远大目标拆成可交付任务',
            culture3Title:'工程评审',
            culture3Desc:'技术方案充分讨论',
            culture4Title:'项目激励',
            culture4Desc:'项目成功后透明分享收益',
            valuesIntro:'把产品价值观和组织价值观统一到“让复杂研发协作更清楚、更可信、更高效”这一件事上。',
            value1Desc:'说真话、做实事，用坦诚建立长久的合作关系。',
            value2Desc:'彼此支持、相互补位，一起把好想法变成好成果。',
            value3Desc:'不只解决今天的问题，也为未来多走一步。',
            value4Desc:'不浪费生命，自主学习，成就自己，获得收益。',
            joinIntro:'如果你认同远程信任、工程师文化和高效交付，我们期待你加入。',
            joinRole1Desc:'参与 ALM、AI 与工程工具链能力建设。',
            joinRole2Desc:'连接研发交付与稳定运维，保障系统安全、高效运行。',
            joinRole3Desc:'连接用户需求与产品体验，让复杂功能变得清晰、直观、易用。',
            jingli1:'公司成立',
            jingli2:'产品发布',
            jingli3:'政府科研人才项目',
            jingli4:'企业荣誉',
            jingli5:'客户进展',
            desc1:'云体科技开启汽车ALM的国产自研',
            desc2:'MappingSpace产品发布，正式打破国外垄断',
            desc3:'苏州金鸡湖领军人才企业、姑苏领军人才企业，获得政府超百万科研经费补贴',
            desc4:' 获评“国家高新技术企业”',
            desc5:'企业付费客户达到几十家，帮助多家企业通过ASPICE、ISO26262、ISO21434认证 ',
            jingli6:'功能安全双认证',
            desc6:'MappingSpace ALM 通过 ISO 26262 与 IEC 61508 的工具认证。',
        },
        award:{
            title1:'企业荣誉资质',
            desc1:'2024年高新技术企业，连续3年科技型中小企业',
            title2:'专利与软著',
            desc2:'完整的自主知识产权，强大的研发实力（8专利+12软著）',
            title3:'产品检测认证证书',
            desc3:'通过江苏省软件检测结构的质量检测认证与信创适配认证',
            title4:'众多国内外软件战略合作伙伴',
            desc4:'',
            bottom4:`蜚语科技——国产嵌入式静态代码扫描第一品牌
                    伊世智能——国产车载网络信息安全服务提供商
                    星云测试——国产嵌入式代码精准测试提供商
                    德国Accemic GmbH公司嵌入式代码分支覆盖度工具提供商
                    ……`,
            bottom4_title:'其余战略合作单位：',
        },
        cooperations: "合作伙伴"
    },
    funSafety:{
        hara:{
            info:'危害分析及风险评估（HARA）',
            title:'智能计算功能安全等级',
            desc1:'预设HARA分析案例，助您轻松上手',
            desc2:'基于HAZOP方法，深度探索功能故障与危害',
            desc3:'智能计算ASIL安全等级，明确安全目标',
            desc4:'思维导图展现HARA全貌',
        },
        dfmea:{
            info:'DFMEA',
            title:'新版七步法，实时跟踪改进措施',
            desc1:'预设DFMEA案例，零基础也能上手',
            desc2:'基于思维导图，智能填充结构、功能、失效分析,高效便捷',
            desc3:'SOD自动计算，洞察措施优先级',
            desc4:'实时追踪改进措施，清晰展示数据报表',
        },
        fta:{
            info:'故障树分析（FTA）',
            title:'自动计算FTA各类指标',
            desc1:'自动计算FTA核心指标，洞察系统脆弱点',
            desc2:'预设FTA分析案例，助您快速入门',
            desc3:'基于思维导图，展现清晰的FTA全景',
            desc4:'自动计算最小割集、最小径集、结构重要度、顶事件发生概率，提升效率',
        }
    },
    client: { // 客户
        customerPage1: {
            title: {
                aotecar: '全球领先的新能源汽车零部件平台',
                TongyuAutomobile: '线控底盘关键技术领跑者',
                Fuerda: '高端汽车智能光电系统',
            },
            content: {
                aotecar: '借助MappingSpace研发管理系统，拓普完成了项目数据的整体线上迁移，满足严苛的欧洲客户要求。',
                TongyuAutomobile: '借助MappingSpace研发管理系统，利氪科技实现了线控底盘功能安全项目的高效管理，从而满足ISO26262提出的标准要求。',
                Fuerda: '借助MappingSpace研发管理系统，实现了对IBM Doors软件的国产替代，并大大超出了原有工具的使用效率和使用体验。',
            }
        },
        customerPage2: {
            title: {
                aotecar: '关于拓普',
                TongyuAutomobile: '关于利氪科技',
                Fuerda: '关于福尔达',
            },
            content1: {
                aotecar: '宁波拓普集团股份有限公司是在上海证券交易所上市的一家科技、平台型汽车零部件企业（股票代码：601689），主要致力于汽车动力底盘系统、饰件系统、智能驾驶系统等领域的研发与制造。',
                TongyuAutomobile: `上海利氪科技有限公司（SHANGHAI LEEKR TECHNOLOGY CO.,LTD.）深耕汽车底盘核心领域数十年，核心成员均来自国际一流汽车零部件供应商及整车厂领先的智能线控底盘系统方案商。`,
                Fuerda: '宁波福尔达智能科技股份有限公司自1995年成立以来，坚持“以技术引领市场、以创新追求发展”的经营方针，现拥有优秀的专业技术研发人才，并具备对光、机、电、软硬件智能集成控制系统产品、高精尖模具、智能装备（自动化装配、智能在线检测生产线等）的自主创新设计开发、制造、配套服务整合的能力。',
            },
            content2: {
                aotecar: '拓普集团自1983年创立，总部位于中国宁波，在汽车行业中专注笃行40余年。集团设有动力底盘系统、饰件系统、域想智行和电驱四大事业部，主要生产减震系统、内外饰系统、车身轻量化、底盘系统、智能座舱部件、热管理系统、空气悬架系统、智能驾驶系统和执行器等产品 。',
                TongyuAutomobile: '利氪科技是领先的智能线控底盘系统方案商。公司聚焦新能源汽车和自动驾驶核心领域，依托完整的线控底盘平台开发能力和应用落地能力，以高难度线控制动技术作为切入，率先推出全球首款可量产的液压全解耦线控制动技术方案DHB-LK®（Decoupled Hydraulic Booster）和国际尖端技术集成式智能制动系统IHB-LK®（Integrated Hydraulic Brake），产品性能达世界领先水平，已获得国内多家车企项目定点，其中DHB-LK®产品已于2022年7月实现小批量量产，IHB-LK®产品于2022年12月实现量产。',
                Fuerda: '公司在慈溪、宁波、上海设有三个研发中心和五个制造基地；在德国设有子公司及研发中心，开展与海外整车厂同步设计开发、市场营销服务等工作；2021年在罗马尼亚筹建生产基地，确保欧洲及全球供货的能力，进一步开拓海外市场。',
            },
            content3: {
                aotecar: '集团始终坚持研发与创新，拥有支持全球项目的研发中心和装备领先的试验中心。凭借领先的研发技术、制造技术、质量管理和全球供应能力，拓普集团与国内外多家汽车制造商建立了良好的合作关系，已成为奥迪、宝马、斯特兰蒂斯、通用、吉利、福特、奔驰、大众、理想、蔚来、小鹏、RIVIAN、LUCID等汽车制造商的全球合作伙伴。-路虎等世界知名汽车生产厂商，在中国市场和其他新兴市场国家也拥有广泛客户。目前公司人员规模8000余人，公司拥有自主知识产权，发明专利158项，公司通过不断的研发积累，逐步形成自身的核心技术。',
                TongyuAutomobile: '未来，利氪科技将全面布局线控制动、线控转向、线控底盘域控制器，逐步打造完整线控底盘产品生态，为车企和产业提供安全、高效、智能的线控底盘完整解决方案。',
                Fuerda: '公司建立了完善的管理体系，通过了IATF16949、ISO45001、ISO14001体系认证。福尔达曾先后被评为“国家重点高新技术企业”和“国家火炬计划重点高新技术企业”、“浙江省绿色企业”、“浙江省高新技术企业研究开发中心”、 “浙江省省级企业研究院”、“浙江省高新技术企业创新能力百强”等称号。已连续十年荣获慈溪市十强企业，2018年荣获慈溪市“亩均论英雄”中第一名，2021年荣获宁波市汽车产业亩均效益领跑企业和浙江省亩均效益领跑企业。',
            },
            card1: {
                title: '挑战1',
                content1: {
                    aotecar: '线下Excel文档难以建立准确的追溯性，需要花费大量的时间，去解决追溯性和一致性的问题。',
                    TongyuAutomobile: '线控制动系统属于ASIL D等级的功能安全部件，因此需要按照功能安全的流程进行开发',
                    Fuerda: 'ASPICE标准要求的文档和流程特别多，如何满足汽车快速迭代的要求。',
                },
                content2: {
                    aotecar: '思维导图式需求管理，V模型视图展示追溯性，提高管理效率',
                    TongyuAutomobile: '支持HARA、FTA和DFMEA等功能安全分析方法',
                    Fuerda: '敏捷与ASPICE融合，提效同时也可保证质量',
                }
            },
            card2: {
                title: '挑战2',
                content1: {
                    aotecar: '通过查阅word中的版本升级记录表格，无法真正了解需求的历史修改记录。',
                    TongyuAutomobile: '线下存在大量的研发文档，需要尽快迁移到线上工具中，实现数字化管理。',
                    Fuerda: 'IBM Doors学习门槛很高，引入MappingSpace这个新工具是否会有更高的学习门槛？如何替代Doors。',
                },
                content2: {
                    aotecar: '随时查看需求修改历史记录，架构图历史版本可回滚',
                    TongyuAutomobile: 'Word、Excel批量导入，搭好研发数字化基础',
                    Fuerda: '基于思维导图的系统工程，全局思维尽在掌握',
                }
            },
            card3: {
                title: '挑战3',
                content1: {
                    aotecar: '针对过程文件的评审记录，以及评审之后建立问题的追踪历史，需额外维护更多的文件，及建立更为复杂的追溯性。',
                    TongyuAutomobile: '客户项目太多，如何解决项目复用的问题？项目复用之后，追溯性是否需要重新建立？',
                    Fuerda: '项目管理任务繁重，并且面临着多项目并行，能否使用工具，替代一部分项目经理的工作。',
                },
                content2: {
                    aotecar: '多人实时评审，自动生成评审记录及评审数据报表，提高评审效率',
                    TongyuAutomobile: '项目复用及追溯性继承，平台项目与车型项目并行开发',
                    Fuerda: '甘特图工时统计，实时出具数据报表',
                }
            },
            learn: '了解更多'
        },
        customerPage3: {
            solve: '问题解决思路及工具场景落地：',
            next: '下一个',
            previous: '上一个',
            card1: {
                title: {
                    aotecar: '思维导图式需求管理，V模型视图展示追溯性，提高管理效率',
                    TongyuAutomobile: '支持HARA、FTA和DFMEA等功能安全分析方法',
                    Fuerda: '敏捷与ASPICE融合，提效同时也可保证质量',
                },
                content: {
                    aotecar: '甲方客户维护了较多线下流程文档（系统需求规格说明书、测试规格说明书、跟踪矩阵，均为Excel格式）。在规格说明书中，每条需求存在数十列待填信息，需维护系统需求ID、干系人需求ID、需求组ID等，用于建立需求之间的追溯性；在跟踪矩阵文件中，维护全部的系统需求、系统架构、软件需求、软件架构、软件详设，每张表中均需要维护ID号及建立追溯。',
                    TongyuAutomobile: '集成式电子液压制动系统iEHB，集成了EHB、EPB、ESC三大制动产品，可实现高品质的基础制动、线控制动、线控驻车、稳定性控制等功能，并可作为底盘域控制器全面接管线控底盘。但iEHB作为自动驾驶场景中的关键部件，具有非常高的功能安全等级，因此需要进行功能安全产品认证。',
                    Fuerda: '敏捷开发强调快速迭代、适应变化和持续交付，而ASPICE则在安全和质量要求方面有非常严格的规定。如果不融合ASPICE，敏捷团队在汽车行业可能面临的问题：',
                    li1: '- 符合性问题：不能满足行业规范要求，影响产品认证和上市；',
                    li2: '- 安全风险：可能无法确保产品的安全和可靠性，难以做到对软件生命周期的全方位管理，如质量保证、终身管理等；',
                    li3: '- 客户信任缺失：客户对敏捷开发出的软件系统的信心缺失，特别是对那些可能影响生命安全的系统。',
                },
                li1: {
                    aotecar: '基于甲方客户的字段要求，在MappingSpace中轻松配置各类型字段；',
                    TongyuAutomobile: 'HARA、FTA和DFMEA分析模块，作为MappingSpace工具的一部分，因此功能安全分析过程和设计过程紧密结合；',
                    Fuerda: '将线下的Word、Excel一键导入到MappingSpace中，形成原子化、条目化管理，使用Scrum和Kanban的敏捷开发模式；',
                },
                li2: {
                    aotecar: 'MappingSpace提供了Excel和Word两种导入方式，快速将线下文档线上化，每一条需求均建立全局唯一的ID；',
                    TongyuAutomobile: '将DFMEA的优化措施，直接与设计任务关联起来，而无需考虑打通不同工具，节省了大量的人力成本和工具购买成本。',
                    Fuerda: '建立需求、架构、详细设计、测试用例之间，原子级别的追溯性；',
                },
                li3: {
                    aotecar: '以思维导图的视角，展示需求的层级关系，并建立需求之间的追溯性；',
                    Fuerda: '使用MappingSpace中原生的基线管理、变更管理、在线评审的功能，满足ASPICE 全生命周期的流程管理。',
                },
                li4: {
                    aotecar: '以V模型视图，展示全局的追溯性，并自动生成V模型跟踪矩阵',
                }
            },
            card2: {
                title: {
                    aotecar: '随时查看需求修改历史记录，架构图历史版本可回滚',
                    TongyuAutomobile: 'Word、Excel批量导入，搭好研发数字化基础',
                    Fuerda: '基于思维导图的系统工程，全局思维尽在掌握',
                },
                content: {
                    aotecar: '在word时代，需求的修改历史记录，往往通过在word中增加“历史修改记录”表格来完成，但真正修改了哪些细节，或者出于什么原因需要修改，都无从得知；另一种方案，则是通过保存多个版本的word、excel文件，但是人工比较多个版本的差异，效率太低。最终导致了需求变更的不可查阅。',
                    TongyuAutomobile: '在工具进入之前，研发团队将大量的过程文档保存在线下。这种做法导致了一些管理上的缺陷。首先，线下存储过程文档导致信息不易获取和共享。团队成员需要花费大量时间来搜索和获取所需文档，延迟项目进展。其次，由于无法实时更新和编辑线下文档，团队成员可能会错过最新的变更和更新，从而影响项目的准确性和一致性。',
                    Fuerda: '已经使用IBM Doors产品很多年了，但发现该产品的缺陷越来越明显：价格昂贵，产品易用性不好，用户界面比较陈旧且不直观，新用户学习起来可能比较困难，与其他开发工具的集成有时可能复杂，特别是跟非IBM的产品。我们希望引入新工具来替代这款产品，但是我们担心引入新工具会进一步增加工具链的复杂度，使得工具更加难以落地。',
                },
                li1: {
                    aotecar: '需求中每个字段的修改，都有详细的历史记录，包括修改人、修改时间、修改内容；',
                    TongyuAutomobile: '将线下的word、excel文档，批量导入到MappingSpace中，快速实现了需求的条目化；',
                    Fuerda: 'MappingSpace采用了基于思维导图的系统工程（MMBSE）概念，与MBSE如出一辙，它最大的优势就是直观、易学，只要掌握了思维导图的基本操作，就能在MappingSpace上大力发挥自己的优势；',
                },
                li2: {
                    aotecar: 'MappingSpace中内置了架构图绘图工具drawio，作为全球最受欢迎的开源UML绘图工具，拥有远超越visio的功能特性，并且支持架构图历史记录回滚。',
                    TongyuAutomobile: '线上的条目化需求，也可以重新导出成word或excel，便于和第三方客户进行信息共享。',
                    Fuerda: '在工具导入阶段，云体科技通过培训、答疑等方式，和客户一起探索。云体科技拥有非常资深的汽车领域工具链专家，同时，网上有众多云体科技专家录制的工具操作视频，以及撰写的专业技术文章，帮助客户落地。',
                },
            },
            card3: {
                title: {
                    aotecar: '多人实时评审，自动生成评审记录及评审数据报表，提高评审效率',
                    TongyuAutomobile: '项目复用及追溯性继承，平台项目与车型项目并行开发',
                    Fuerda: '甘特图工时统计，实时出具数据报表',
                },
                content: {
                    aotecar: '当需求被写出来之后，需要经历评审。在甲方客户内部，需求的评审非常严格，需要包含需求的评审过程、评审条目，以及评审完之后的修改过程，需要有过程记录。使用线下工具，评审记录和修改记录，都在邮件中，难以建立起有效的追溯性。',
                    TongyuAutomobile: '项目经理同时管理多个车型项目的开发，过程文档的重复度很高，之前过程文档一直在线下管理，未能建立完整的追溯性，新车型项目开始时，直接整体复制原项目的所有过程文档，改动量大，且改动后的设计，无法知晓是否应用到其他车型项目；项目经理需要同时处理多家客户的需求，和客户沟通的方式主要采取邮件沟通、excel表格等，效率较低。',
                    Fuerda: '作为项目管理中最重要的工具之一，甘特图非常重要。但我们一直没有碰到合适的甘特图工具，能够与我们的研发管理系统结合到一起。我们希望研发设计任务，只需要被创建一遍，就可以同时被加入到甘特图里面，而不是重复创建。同时我们希望在甘特图里，跟踪每个人的实际时间投入和理论估计的差别，并且能通过数据报表，实时反馈这种差距。',
                },
                li1: {
                    aotecar: '将甲方客户的checklist，直接在MappingSpace的“评审配置”处轻松进行配置；',
                    TongyuAutomobile: '我们建议客户改变原有的独立项目开发模式，转而同时维护平台项目和车型项目，因此我们给客户制订了两套方案，供用户选择，通过最大程度的复用平台项目的过程文档，从而减小项目管理过程中的工作量，客户最终选择了第二套方案并实施，工作效率提高了50%；',
                    Fuerda: 'MappingSpace中的甘特图完美契合了客户的需求，可以轻松地将各类设计任务、项目计划、bug等，加入到甘特图中；',
                },
                li2: {
                    aotecar: '用户自定义评审规则、评审人和评审结束时间；',
                    TongyuAutomobile: '通过建立客户账户，并限制客户在MappingSpace系统中的权限，从而实现与客户的信息传递，保证了信息格式的一致性和时效性，在一个系统中实现对所有客户的问题管理。',
                    Fuerda: '甘特图既可以填写项目经理的预期完成时间，也可以填写工程师的实际所用工时；',
                },
                li3: {
                    aotecar: '自动统计评审结果，自动出具评审数据报表。',
                    Fuerda: '实时、并且自动地出具甘特图的数据报表，任何时候都能支持数据统计。',
                },
            }
        },
        caseCard: {
            title1: '拓普——全球领先的新能源汽车零部件平台',
            title2: '利氪科技——线控底盘关键技术领跑者',
            title3: '福尔达——高端汽车智能光电系统',
            title1Text:'借助MappingSpace研发管理系统，拓普完成了项目数据的整体线上迁移，满足严苛的欧洲客户要求。',
            title2Text:'借助MappingSpace研发管理系统，利氪科技实现了线控底盘功能安全项目的高效管理，从而满足ISO26262提出的标准要求。',
            title3Text: '借助MappingSpace研发管理系统，实现了对IBM Doors软件的国产替代，并大大超出了原有工具的使用效率和使用体验。',
            more:'查看详情'
        }
    },
    toolchain: {  // 汽车工具链
        toolchainPage1: {
            name: '汽车工具链',
            content: 'MappingSpace为您带来更全面、更懂汽车的研发管理工具链',
        },
        toolchainPage2: {
            title: 'MappingSpace和他的朋友们',
            content:'MappingSpace是一款专门为汽车及其他智造工业领域打造的研发管理软件。在ALM领域，我们完全替代Polarion、Doors、Codebeamer的相关产品，接入了多款AI大模型，研发效率大幅提高。与代码仓库、CICD、静态代码扫描工具、测试工具、测试台架等工具的原生集成，为您带来更全面、更懂汽车的研发管理工具链。',
            // content: 'MappingSpace是一款专门为汽车行业打造的研发管理软件。而汽车行业涉及的工具众多，因此我们也积极与一些高效工具进行打通，为您带来更全面、更懂汽车的研发管理工具链。',
            systemRequirement: '系统需求分析',
            systemArchitecture: '系统架构设计',
            SWRequirement: '软件需求分析',
            SWArchitecture: '软件架构设计',
            SWDetailedDesign: '软件详细设计',
            coding: '编码',
            SWUnitVerification: '软件单元测试',
            SWIntegrationTest: '软件集成测试',
            SWQualificationTest: '软件合格性测试',
            systemIntegrationTest: '系统集成测试',
            systemQualificationTest: '系统合格性测试',
        },
        partner: {
            eolink: {
                content: '协助厂商研发团队高效管理 API 文档，并基于 API 文档帮助前后端与测试团队协作，达成快速发起 API 测试、通过 MockAPI协助前后端对接、提供API测试报告输出的能力。',
                content1: '通过与MappingSpace打通，接口设计文档和API接口直接关联，并可在MappingSpace中直接查看API测试报告。',
                li1: '版本管理、差异对比、变更通知，让 API 文档真正可用！',
                li2: '强大的自定义请求校验与响应，便于前后端对接和集成测试等场景！',
                li3: '提供详细的测试报告，包括返回头部、返回结果、性能时间分析等内容！',
                li4: '全面覆盖swagger、postman等API开发管理工具，依托Mappingspace实现工具一体化！',
            },
            feyshTechnology: {
                content1: {
                    title: '使用Corax帮您提升软件质量与安全性，集成MappingSpace满足汽车行业合规需求',
                    content: '软件研发团队可以在流水线上集成Corax的自动代码扫描能力，第一时间发现代码中潜在的BUG与安全漏洞，用极小的代价在软件上线前实现修复。通过与MappingSpace集成，用户可以在MappingSpace查看漏洞扫描报告。',
                },
                content2: {
                    title: '内嵌行业规范 满足合规需求',
                    content: 'Corax内置了MISRA C/C++、AUTOSAR C++、CERT C/C++、CWE、OWASP等汽车行业常用代码质量规范与安全标准，帮助研发团队实现ISO 26262、ISO 21434合规。',
                },
                content3: {
                    title: '兼容GPU编程规范 提升智驾软件稳定性',
                    content: '除了传统的嵌入式研发环境与代码，Corax同样支持对CUDA等异构编程模型进行分析，帮助研发团队有效的提升智能驾驶软件的质量与安全性。',
                },
                content4: {
                    title: '开放接口 实现研发流水线快速集成',
                    content: 'Corax采用模块化设计，代码分析与数据分析能力解耦。研发团队可以使用Corax提供的多种API接口完成流水线的无缝集成，实现在不同研发流程中对代码质量与安全进行监控和管理。',
                }
            },
            gitlab: {
                content1: {
                    title: '顶级的开源顶目',
                    li1: "源代码开放透明，提高代码质量和安全性",
                    li2: '3,300+代码贡献者和10,000+社区贡献者，繁荣的开发者生态',
                    li3: '12年选代 139+版本，保持产品的持续创新',
                },
                content2: {
                    title: '广泛的应用',
                    li1: "10万+私有部署企业用户",
                    li2: '3,000万+注册用户',
                    li3: 'Saas 每月支持数百万个项目和数十万用户',
                    li4: '67% DevOps 私有部署全球市场份额',
                },
                content3: {
                    title: '与MappingSpace高效打通',
                    li1: "通过与MappingSpace集成，用户将代码提交、CICD结果，直接关联到研发过程文档",
                    li2: '提高项目管理效率流程，实现开发任务与代码闭环',
                },
                content4: {
                    title: 'AI赋能',
                    li1: "贯穿软件开发全生命周期的AI能力",
                    li2: '隐私优先的企业级AI服务',
                    li3: '开放透明的AI功能演进路线图',
                },
            }
        }
    },
    informationSecurity: {   // 信息安全
        title: '威胁分析与风险评估（TARA）',
        title1: '满足WP.29-R155信息安全法规',
        li1: '内置WP.29-R155威胁列表和缓解措施数据库，您的私人信息安全问题识别专家',
        li2: '基于思维导图，快速识别信息安全资产',
        li3: '基于SFOP，自动计算危害影响',
        li4: '快速导出TARA分析全局清单'
    },
    industrialIntelligentManufacturing: {   // 工业智造
        industrialPage1: {
            name: '工业智造领域研发管理',
            content: 'MappingSpace满足高精工业领域标准，一站式研发数字化管理平台',
        },
        industrialPage2: {
            title: 'MappingSpace与工业智造领域',
            li1: 'MappingSpace的研发设计理念，起源于汽车行业的功能安全标准ISO 26262，并不断拓展到泛工业化领域，如航空航天（DO-178B/C、DO-254）、医疗器械（IEC-60601）、轨道交通（EN-5012X）、电机设备（IEC-61800）等。',
            li2: 'MappingSpace融合了当前AIGC领域的最新进展，将AI大语言模型用于生成研发过程文档，帮助工程师编写测试用例、生成代码，提供最新的技术查询能力，大大提升研发进度。',
            li3: 'MappingSpace可以帮助客户更快通过行业标准认证，建立高效的研发过程管理，实现企业降本增效。'
        }
    },
    funcPage: {    //功能介绍
        barText1:'概览',
        barText2:'最佳实践',
        barText3:'工具支持',
        barText4:'案例研究',
        barText5: '更多资源',
        trial:'免费试用',
        minjie: {
            title0: '敏捷开发',
            word0: '基于ASPICE标准去实施敏捷开发， 为汽车行业带来小步快跑、持续\n迭代的开发节奏',
            title1: '什么是敏捷开发',
            word1: `敏捷开发不是一种标准，而是一些思想、工具和实践的结合。就像是一个非常优秀的“考生”，写的一份备考指南，里面讲到了很多思路和方法。

                            比如：针对一个需求还不太清晰的产品，不要奢望一次就把需求做对、做完，因为需求还在不断变化中。快速启动，打造一个原型，通过持续地用户反馈和互动，快速迭代下一个版本，使得产品不断进化。在此过程中，用户满意度不断上升，而产品需求也更加清晰。

                            常用的敏捷开发管理工具包括：Scrum、Kanban、需求优先级的排序、敏捷报表、功能回顾会、每日站会等。

                            最著名且最成功的敏捷开发项目，莫过于埃隆·马斯克的猛禽发动机。`,
            title2: '敏捷开发与ASPICE融合的最佳实践',
            word2:{
                w1_0: '需求文档条目化',
                w2_0: '文档是ASPICE合规性的重要基础，通过将文档拆分成一条条需求，给需求分配优先级、将需求分配到个人、将需求关联到冲刺，在团队中执行敏捷开发。',
                w1_1: 'V模型追溯性',
                w2_1: '实现需求-架构-详细设计-测试用例-bug之间的追溯性，并且能实时展示覆盖度数据，从而满足ASPICE对于追溯性的高要求。',
                w1_2: '与CICD工具打通',
                w2_2: '代码提交与合并是敏捷开发中的最重要的活动之一，通过将代码与详细设计或bug关联起来，自动生成版本发布清单，实现更高效的制品发布。'
                },
            title2_5:'',
            word2_5: `AUTO世代 - Automotive Safety GPT 是一款专为汽车电子安全领域打造的智能助手。

                    它结合了功能安全（Functional Safety）、预期功能安全（SOTIF）以及信息安全（Cybersecurity）等多个专业领域专业知识和技能，不论是系统开发中的各种安全挑战，还是复杂的法规合规问题，AUTO世代都能帮助您快速获得可靠的专业建议，为您的汽车安全设计保驾护航。`,
            title3: '工具支持方法',
            word3: `在MappingSpace中，开发过程文档均以思维导图的方式来创建，从而实现了word文档化和需求条目化的双重目的，我们将这一重要的创新称为基于思维导图的系统工程（Mind mapping based systems engineering)。
                    在MappingSpace中，工程师可以轻松的批量创建追溯，而工程师和管理人员，可以随时基于V模型或者W模型的视角查看各类追溯性和覆盖度，从而大大简化了ASPICE的评审流程。`,
        },
         vModel: {
            title0: 'V模型开发流程',
            word0: '无论是ASPICE3.1，还是升级后的4.0，或者支持功能安全与信息安全流程，\n借助灵活的配置页面，MappingSpace总能提供最佳解决方案',
            title1: '什么是V模型开发流程',
             word1: `汽车行业的ASPICE、ISO 26262功能安全、ISO 21434信息安全，其核心开发框架都遵循V模型开发流程。
                     航电领域的DO-178C、DO-278A，核心框架同样遵循V模型开发流程。
                     V模型开发流程大体上包含：系统需求分析与系统架构设计、软件需求分析与软件架构设计、软件详细设计及编码、不同类型的测试用例等。
                     V模型开发流程非常注重文档的留存，以证明其符合特定行业的标准规范。追溯性的要求，则进一步强化了法规监管的要求，以及提高了产品的安全、质量标准。`,
            title2: 'V模型开发流程的最佳实践',
            word2:{
                w1_0: '项目文档模板',
                w2_0: 'V模型开发流程有很高的文档要求，在创建项目之初，提供丰富的文档模板及项目配置模板，可以大大简化团队的工作。',
                w1_1: 'V模型可视化',
                w2_1: '实现需求-架构-详细设计-测试用例-bug之间的追溯性，并且通过可视化的页面，实时展示文档之间的关联。',
                w1_2: '自动生成评审记录',
                w2_2: '评审过程涉及到众多人员，并需要留下评审记录，如果能自动生成评审记录，并自动记录评审问题，则能为团队节约大量时间。'
                },
            title3: '工具支持方法',
             word3: `MappingSpace提供了丰富的ASPICE项目模板、ISO 26262功能安全项目模板、ISO 21434信息安全模板、DO-178C/DO-278A航电项目模板，大幅简化了团队遵循V模型开发的难度，同时大大提高了团队通过评审认证的效率。
                    通过独特的V模型视图和W模型视图，团队成员可以更清晰地查看任务之间的追溯性。
                    MappingSpace独特而简洁的评审界面，为用户提供了最为直观而简洁的评审体验，通过自动收集评审意见，自动呈现给您详细的评审结果。`
        },
        demand: {
            title0: '需求管理',
            word0: '一份结构清晰的需求文档，为一个成功的项目打下最坚实的基础',
            title1: '什么是需求管理',
            word1: `需求编写标志着一个项目的开始。需求管理通常包括：需求编写、需求评审、需求优先级排序、需求分配、需求基线管理、需求变更、需求复用等过程。
                   分类型管理需求，是工业领域的传统。比如在汽车领域，需求被分为：系统需求、软件需求、硬件需求。而在航电领域，需求被分为：高级需求、低级需求、硬件需求。`,
            title2: '需求管理的最佳实践',
            word2:{
                w1_0: '需求的追溯性',
                w2_0: '通过建立需求与架构、详细设计、测试用例等的追溯性，实现需求的完整覆盖度。当需求有变更时，也能够及时地通知到相关人员。',
                w1_1: '结构化需求',
                w2_1: '结构化需求意味着，需求的编写和存储是结构化的，从而能够更加清晰地管理需求的各类属性，实现高效的增删改查。',
                w1_2: '需求复用',
                w2_2: '一个项目下的需求，能够轻松地被复用到其他项目，并且保持追溯性不变。通过需求复用，能够大大提高团队的开发效率。'
                },
            title3: '工具支持方法',
            word3: `借助思维导图模式和Word模式，MappingSpace帮助用户快速实现了需求的文档化和结构化。在MappingSpace里面，需求的颗粒度不会受到Epic、Feature、Story等的限制，用户可以基于自己的需要，无限分解需求，从而实现精细化的需求管理。
                   当一个项目中的需求完成之后，这部分需求可以被轻松地复制到一个新的项目中，连同追溯性一起，被复制到新项目下。在新项目中，需求可以被独立开发。`
        },
        ai: {
            title0: 'AI内容生成技术',
            word0: 'AI可以帮助工程师快速编写需求文档、测试用例、绘制架构图，大幅加快了项目进度',
            title1: '什么是AI内容生成技术',
            word1: `利用人工智能技术来生成内容。

                    如与ChatGPT大模型直接对话，利用AI技术，生成文字、图片、视频等。
                    
                    将AI技术用于工程研发领域，可以帮助工程师快速生成研发过程文档、绘制架构图、生成代码框架。`,
            title2: 'AI内容生成的最佳实践',
            word2:{
                w1_0: 'AI生成产品',
                w2_0: '用户直接向AI描述需求，AI快速生成产品原型及源代码，用户进行快速验证，并向AI提出修改意见，AI基于此进行快速迭代。',
                w1_1: 'AI生成文档',
                w2_1: '利用AI生成大部分文档内容，如一键生成项目管理计划、测试管理计划、电动机需求设计、复杂结构设计等。',
                w1_2: 'AI生成测试用例代码',
                w2_2: 'AI可以理解复杂的产品需求或者开发代码，并且基于此基础上，生成测试用例代码，提高单元测试的效率。'
                },
            word2_5:`AUTO世代 - Automotive Safety GPT 是一款专为汽车电子安全领域打造的智能助手。
            
            它结合了功能安全（Functional Safety）、预期功能安全（SOTIF）以及信息安全（Cybersecurity）等多个专业领域专业知识和技能，不论是系统开发中的各种安全挑战，还是复杂的法规合规问题，AUTO世代都能帮助您快速获得可靠的专业建议，为您的汽车安全设计保驾护航。`,
            title3: '工具支持方法',
            word3: `在MappingSpace中，用户可以随时和内置的AI机器人对话，无论是帮您写文档，还是画架构图，或者生成代码，AI机器人都乐此不疲。

                    借助全新的MappingGPT，您只需要输入一句最简单的需求描述，AI机器人立刻帮您生成详细的需求分解文档、项目计划、开发任务、实现代码，并实现自动编译与部署。您只需要在此基础上，作进一步地测试验证与修改。`
        },
        test: {
            title0: '测试管理',
            word0: '无论是手动测试用例，还是自动化测试脚本，MappingSpace总能提供最佳的追溯性解决方案',
            title1: '什么是测试管理',
            word1: `测试管理至少包含了：测试用例的管理，测试用例的评审、测试计划的管理，测试报告的管理，Bug 的创建及跟踪，测试用例与需求的关联。
                    此外，测试管理可能还涉及，如何将需求与自动化测试脚本关联起来，如何管理测试台架，如何集中化管理测试报告等。`,
            title2:'测试管理的最佳实践',
            word2:{
                w1_0: '自动选择测试用例',
                w2_0: '明确了待测软件包之后，自动从测试用例仓库中筛选出需要执行的测试用例，并在执行完成之后，自动生成测试报告。',
                w1_1: '测试用例与需求追溯',
                w2_1: '批量创建测试用例与需求的追溯性，并且能够实时查看各类需求的覆盖百分比。',
                w1_2: '自动化测试管理',
                w2_2: '与各类自动化测试工具打通，建立自动化测试用例与需求之间的追溯性，同时能够将测试报告汇总到统一页面，展示更完整的测试结果。'
                },
            title3: '工具支持方法',
            word3: `MappingSpace能够同时支持手动测试用例和自动化测试用例的管理，并能够与多款自动化测试管理工具打通。\
                    在创建测试计划后，根据本次测试计划对应的开发范围，自动将测试用例添加到测试计划中，也可手动增添测试用例，便于精准创建测试计划及回归测试计划，减少每次添加测试用例的工作量。
                    测试用例能够与需求创建双向追溯，并且在后续的项目复用过程中，保持追溯性关联关系不变，大幅提高了项目复用的效率。`
        },
        baseLine: {
            title0: '基线与变更',
            word0: '基线管理的本质，既要记录项目的起点，还需要记录基于起点的变更历史记录',
            title1: '什么是基线与变更',
            word1: `在最新的ASPICE标准中，Baseline一词出现了出现了32次之多，可见基线管理的重要性。
                    项目管理通常包含了多个阶段，如市场调研、概念设计、原型设计、产品定义、功能设计、架构设计等。基线是每一阶段中，特定时间段内项目的起点。在这个起点，包含了这个时间段内，整个项目的所有要求、设定、规范等一切输入。
                    变更通常是指针对特定基线的变更。由于基线定义了起点，如需针对起点进行修改，通常涉及到团队的各类人员，因此需要有变更评审流程。`,
            title2:'基线与变更的最佳实践',
            word2:{
                w1_0: '随时创建基线',
                w2_0: '创建一条基线，并能随时将过程文档加入到基线中。基线的权限可以限制到个人，并能随时向整个团队展示基线内容，确保整个团队基于同一条基线做开发。',
                w1_1: '随时提交变更要求',
                w2_1: '提交变更的方式要方便快捷，并且能够帮助识别变更影响范围、变更评审委员会等。',
                w1_2: '随时记录基线变化',
                w2_2: '当变更发生时，势必会对基线内容产生影响。能够实时地展示基线变更历史记录，确保所有相关人都被通知到。'
                },
            title3: '工具支持方法',
            word3: `基线与变更应该被视为一个整体来进行管理，正是由于经常需要变更，才需要记录过程中的每一个状态。
                    MappingSpace借鉴git中主线与分支的概念，使得每个人都可以随时基于需要，提交变更请求。变更请求的最终批准，总是需要变更委员会的审批，从而确保变更请求的合理性。`
        }
    },
    freetrial: {
        title: '选择服务器区域',
        subtitle: '选择距离您最近的数据中心，以获得最佳性能和最低延迟，选择错误的版本可能导致部分功能不可用，请根据您的实际需求选择对应版本',
        ipDetect: '系统检测到您的IP位于',
        china: '中国',
        chinaVersion: {
            country: '中国版',
            service: '中国大陆服务器',
            recommand: '推荐选择',
            descTitleOne: '低延迟',
            descDetailOne: '中国大陆方向优化直连，极速稳定，拒绝丢包',
            descTitleTwo: '本地化支持',
            descDetailTwo: '提供中文界面及配套文档',
            btn: '选择中国版'
        },
        internationalVersion: {
            country: '国际版',
            service: '全球服务器网络',
            recommand: '全球访问',
            descTitleOne: '全球 CDN 加速',
            descDetailOne: '分布式服务器遍布全球，确保从各大洲都能获得快速、高可用的访问体验',
            descTitleTwo: '多语言支持',
            descDetailTwo: '针对英语及其他国际语言进行优化，符合全球合规标准',
            btn: '选择国际版'
        }
    }
}
          
